export enum ContactFormDataTarget {
  FORM_CONTAINER = "contact-form-container",
  FORM_TITLE = "contact-form-title",
  NAME_INPUT = "contact-form-name-input",
  EMAIL_INPUT = "contact-form-email-input",
  SUBJECT_INPUT = "contact-form-subject-input",
  PHONE_INPUT = "contact-form-phone-input",
  COMMENT_INPUT = "contact-form-comment-input",
  FILE_UPLOAD = "contact-form-file-upload",
  FILE_UPLOAD_ICON = "contact-form-file-upload-icon",
  FILE_CAROUSEL = "contact-form-file-carousel",
  FILE_ITEM = "contact-form-file-item",
  REMOVE_FILE_BUTTON = "contact-form-remove-file-button",
  SUBMIT_BUTTON = "contact-form-submit-button",
  SUCCESS_MESSAGE = "contact-form-success-message",
  ERROR_MESSAGE = "contact-form-error-message",
  FIELD_LABEL = "contact-form-field-label",
}
